import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { jwtDecode } from "jwt-decode";
import utilsService from '@/api/utilsService';
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});


router.beforeEach(async (to, from, next) => {
  utilsService.syncSessionFromShared();
  const token = localStorage.getItem('user-session');
  const isAuthenticated = !!token;

  try {
    // 'FichaPublica' y 'AbrirFichaPublica' se comparten fuera de la plataforma (link del PDF),
    // por lo que deben resolverse sin sesión.
    const publicRoutes = ['login', 'register', 'forgot-password', 'request-password-reset', 'registro-comprador',
                          'FichaPublica', 'AbrirFichaPublica'];
    if (publicRoutes.includes(to.name)) {
      next();
      return;
    }
    else if (!isAuthenticated) {
      next({ name: 'login' });
      return;
    }
    else if (isAuthenticated) {
      
      let userRole = '';
      const decoded = jwtDecode(token);
      userRole = decoded.rol || '';

      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        localStorage.removeItem('user-session');
        next({ name: 'login' });
        return;
      }

      // Validar acceso a detalle de usuario (propio perfil o roles permitidos)
      if ((to.name == 'usuario-detalle') && (decoded.userid != to.params.id)) {
        const allowedRoles = to.meta.roles || [];
        if (!allowedRoles.includes(userRole)) {
          next({ name: 'error' });
          return;
        }
      }
      
      // Validar roles permitidos en la ruta
      if (to.meta.roles && Array.isArray(to.meta.roles)) {
        const allowedRoles = to.meta.roles.map(r => r.toLowerCase().trim());
        const normalizedUserRole = userRole.toLowerCase().trim();
        
        if (!allowedRoles.includes(normalizedUserRole)) {
          next({ name: 'error' });
          return;
        }
      }
      
      // Validación legacy para requiresAdmin
      if (to.meta.requiresAdmin && userRole !== 'admin') {
        next({ name: 'error' });
        return;
      }
      
      next();
      return;
    } 
    next();
  } catch (error) {
    next();
    return;
  }
});

export default router;
